import React from 'react';
// import moment from 'moment';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CustomTableCell from '../../models/table/CustomTableCell';
import IconButton from '@material-ui/core/IconButton';
import { presentFormatedData } from '../../functionalComponents/dataFormatFunctions';
import { makeStyles, Typography } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { header } from './header';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  logo: {
    display: 'flex',
    border: '1px solid #000000',
    borderRadius: '8%',
    padding: '0.3rem',
    width: 'fit-content',
    justifySelf: 'center',
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  logoHeight: {
    height: 'inherit',
  },
  changingWidth: {
    width: '6%',
    // maxWidth: 0,
    [theme.breakpoints.between('sm', 'xl')]: {
      width: '2%',
    },
    // [theme.breakpoints.down('sm')]: {
    //   width: '6%',
    //   maxWidth: 0,
    // },
  },
}));

const renderStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: //"Created"
      color = "#B4B4B4"; // Bright orange for Ongoing
      break;
    case 23: //"Under confirmation":
      color = "#E78A00"; // Green for Completed
      break;
    case 22: //"Shared with CMO":
      color = "#2196F3"; // Grey for Awaiting Start
      break;
    case 25: //"Confirmed":
      color = "#707070"; // Grey for Awaiting Start
      break;
    case 27: //"Approved":
      color = "#329429"; // Grey for Awaiting Start
      break;
    case 24: //"Rejected By CMO":
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
      }}
    >
      {statusText}
    </Typography>
  );
};

function SingleRow(props) {
  const classes = useStyles();
  const { SADetails, setOpen, open, openPOLineDetails, customizeTable, featuresAccess } = props;
  const { SLDetails } = SADetails;

   const screenAccess = useSelector(
            (state) =>
              state.pcmp.common.accessControl.screensAccess?.data.poLineDashboard?.screenAccess
          );

  // let customizeRowFlag = customizeTable || (Array.isArray(customizeTable) && customizeTable?.length !== 0)
  return (
    <React.Fragment>
      <TableRow
        className={classes.root}
        style={{
          backgroundColor: props.keys % 2 === 0 ? '#FFF' : '#0000000a',
        }}
        key={SADetails.schrockenSAID}
      >
        <TableCell
          size='small'
          style={{
            maxWidth: '0.4rem',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            padding: 0,
          }}
        >
          {SLDetails.length > 0 ? (
            <IconButton
              aria-label='expand row'
              size='small'
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : null}
        </TableCell>

        {/* {!customizeRowFlag
          ?  <CustomTableCell
          scope='row'
          align='left'
          elementStyle={{ maxWidth: '0px' }}
        >
          {presentFormatedData(SADetails.scheduleAgreementNumber)}
        </CustomTableCell>
          : customizeTable.filter((val) => val?.id === 'poline').length > 0
            ? customizeTable.filter((val) => val?.id === 'poline')[0]?.active
              ? <CustomTableCell
              scope='row'
              align='left'
              elementStyle={{ maxWidth: '0px' }}
            >
              {presentFormatedData(SADetails.scheduleAgreementNumber)}
              </CustomTableCell>
              : null
            : <CustomTableCell
            scope='row'
            align='left'
            elementStyle={{ maxWidth: '0px' }}
          >
            {presentFormatedData(SADetails.scheduleAgreementNumber)}
            </CustomTableCell>
        } */}

        {header(localStorage.collabType !== "CMO", true, customizeTable,featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'poline').length > 0
          ? <CustomTableCell
          scope='row'
          align='left'
          elementStyle={{ maxWidth: '0px' }}
        >
          {presentFormatedData(SADetails.scheduleAgreementNumber)}
          </CustomTableCell>
          :
          null
        }

        {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'cdmoPlant').length > 0
          ? <CustomTableCell
          scope='row'
          align='left'
          elementStyle={{ maxWidth: '0px' }}
        >
          {presentFormatedData(SADetails.vendorName)}
          </CustomTableCell>
          :
          null
        }

{header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'sponsor').length > 0
          ? <CustomTableCell
          scope='row'
          align='left'
          elementStyle={{ maxWidth: '0px' }}
        >
          {presentFormatedData(SADetails.sponsorName)}
          </CustomTableCell>
          :
          null
        }
        
        {/* {localStorage.collabType !== "CMO" &&
          
        } */}

{['productCodeDescription', 'dateOfDelivery', 'deliveredQty', 'viewBatches'].map(column => {
  const isColumnVisible = header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches)
    .some(val => val.id === column);

  return isColumnVisible ? (
    <CustomTableCell
      key={column}
      scope='row'
      align='center'
      elementStyle={{ maxWidth: '0px' }}
    >
      {/* Add content inside the cell if needed */}
    </CustomTableCell>
  ) : null;
})}
        

        {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'poStatus').length > 0
          ? <CustomTableCell
          scope='row'
          align='center'
          elementStyle={{ maxWidth: '7rem' }}
        >
          {renderStatusButton(
                            presentFormatedData(SADetails.scheduleAgreementStatusID),
                            presentFormatedData(SADetails.scheduleAgreementStatusText)
                          )}
        </CustomTableCell>
          :
          null
        }
        

        {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'actions').length > 0
          ? <CustomTableCell className={classes.changingWidth} align='center'>
            {screenAccess &&
              <div className={classes.logo}
              onClick={() => openPOLineDetails(SADetails)}
            >
              <VisibilityIcon className={classes.logoHeight} />
            </div>
            }
          
          </CustomTableCell>
          :
          null
        }

        
      </TableRow>
    </React.Fragment>
  );
}
export default SingleRow;
